// extracted by mini-css-extract-plugin
module.exports = {"link":"_1sUSC","imageContainer":"tJuUG","image":"_2gLKK","title":"_3FR06"};